import { gql } from "@apollo/client";

export const CREATE_CUSTOMER_LOCATION = gql`
  mutation CreateCustomerLocation($location: String!) {
    createCustomerLocation(location: $location) {
      id
      is_active
    }
  }
`;

export const DELETE_CUSTOMER_LOCATION = gql`
  mutation DeleteCustomerLocation($id: ID!) {
    deleteCustomerLocation(id: $id) {
      message
    }
  }
`;